import {
	PostRequestUploadDocParams,
	PostRequestUploadDocResponse,
} from 'domain/usecases/others/facial-biometric';
import {makePostRequestFacialBiometricUploadDoc} from 'main/factories/usecases/others/facial-biometric/request/post-upload-doc';

export const postUploadDoc = async (
	params: PostRequestUploadDocParams,
): Promise<PostRequestUploadDocResponse> => {
	const response = await makePostRequestFacialBiometricUploadDoc().post(params);
	return response;
};
